module.exports = __webpack_public_path__ + "img/hontai_L8149.f7d298ce.png";